<div class="orders-page">
  <div class="orders-toolbar">
    <app-sort-dropdown
      dropdownId="ordersSortDropdown"
      [options]="sortOptions"
      [selected]="selectedSort"
      (selectedChange)="onSort($event)">
    </app-sort-dropdown>

    <app-search-input
      [(searchText)]="searchText"
      placeholder="Пребарај по име, број, или датум..."
      (search)="loadOrders()">
      <div search-prefix class="position-relative h-100">
        <button
          class="btn app-btn-soft app-btn-square rounded-end-0 position-relative"
          type="button"
          aria-label="Филтрирај налози"
          aria-controls="ordersFilterOptions"
          [attr.aria-expanded]="filtersOpen"
          (click)="toggleFilters($event)">
          @if (selectedCount != filterOptions.length) {
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill primary-bg">
              {{ selectedCount }}
              <span class="visually-hidden">active filters</span>
            </span>
          }
          <fa-icon [fixedWidth]="true" size="sm" [icon]="faPlus"></fa-icon>
        </button>

        @if (filtersOpen) {
          <div id="ordersFilterOptions" class="filter-dropdown shadow rounded" role="group" aria-label="Филтри за налози">
            @for (option of filterOptions; track $index) {
              <button
                type="button"
                class="filter-option"
                role="checkbox"
                [attr.aria-checked]="option.selected"
                (click)="chooseFilter(option, $event)">
                <span
                  class="filter-option-checkbox"
                  [class.selected]="option.selected"
                  aria-hidden="true">&#10003;</span>
                <span>{{ option.label }}</span>
              </button>
            }
          </div>
        }
      </div>
    </app-search-input>

    <a
      routerLink="/orders/create"
      aria-label="Додади налог"
      class="btn primary-btn app-btn-toolbar rounded-4 d-flex align-items-center justify-content-center gap-2">
      <fa-icon [icon]="faPlus"></fa-icon>
      <span class="d-none d-sm-inline">Додади</span>
    </a>
  </div>

  @if (loading) {
    <app-loading-spinner></app-loading-spinner>
  }

  @if (error) {
    <app-error-alert class="d-block mb-3" [message]="error"></app-error-alert>
  }

  @if (!loading && orders && orders.items.length > 0) {
    <div class="orders-list-shell">
      <div class="orders-column-header" aria-hidden="true">
        <span>Налог</span>
        <span>Пациент</span>
        <span>Датум</span>
        <span>Содржина</span>
        <span>Статус</span>
        <span></span>
      </div>

      <div class="orders-list">
        @for (order of orders.items; track order.id) {
          <ng-container [ngTemplateOutlet]="orderCard" [ngTemplateOutletContext]="{$implicit: order}" />
        }
      </div>

      <mat-paginator
        class="orders-paginator"
        [length]="orders.totalCount"
        [pageIndex]="orders.currentPage - 1"
        [pageSize]="orders.pageSize"
        [pageSizeOptions]="[1, 5, 10, 25, 50]"
        [showFirstLastButtons]="true"
        [hidePageSize]="true"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  } @else if (!loading && !error) {
    <app-no-items-found text="Не се пронајдени налози."></app-no-items-found>
  }
</div>

<div class="modal fade" id="deleteOrderModal" tabindex="-1" aria-labelledby="deleteOrderModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteOrderModalLabel">Избриши налог</h5>
        <button type="button" class="btn-close" aria-label="Затвори" [disabled]="deletingOrder" (click)="hideDeleteOrderModal()"></button>
      </div>
      <div class="modal-body">
        Дали сте сигурни дека сакате да го избришете налогот
        @if (pendingDeleteOrder?.patientName) {
          <strong>{{ pendingDeleteOrder?.patientName }}</strong>
        }?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [disabled]="deletingOrder" (click)="hideDeleteOrderModal()">Назад</button>
        <button type="button" class="btn btn-danger" [disabled]="deletingOrder" (click)="confirmDeleteOrder()">
          @if (deletingOrder) {
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            Бришење...
          } @else {
            <fa-icon [icon]="faTrash"></fa-icon>
            Избриши
          }
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #orderCard let-order>
          <article
            class="order-card"
            [class.expanded]="expandedOrderIds.includes(order.id)">
          <button
            type="button"
            class="order-summary"
            [attr.aria-expanded]="expandedOrderIds.includes(order.id)"
            [attr.aria-controls]="'order-details-' + order.id"
            (click)="toggleExpand(order.id)">
            <span class="order-number">{{ order.formattedOrderNumber }}</span>
            <span class="order-info">
              <span class="patient-name">{{ order.patientName }}</span>
              <span class="order-date">{{ order.dateCreated | appDate:'date':formatting.formats() }}</span>
            </span>

            <span class="order-work-summary">
              <span class="order-work-metric">
                <fa-icon [fixedWidth]="true" [icon]="faTooth"></fa-icon>
                <span>{{ groupProductsByName(order.products).length }}</span>
                <span class="visually-hidden">изработки</span>
              </span>
              <span class="order-work-divider" aria-hidden="true"></span>
              <span class="order-work-metric">
                <fa-icon [fixedWidth]="true" [icon]="faPaperclip"></fa-icon>
                <span>{{ order.files.length }}</span>
                <span class="visually-hidden">датотеки</span>
              </span>
            </span>

            <span class="order-status-cell">
              @if (order.orderStatus === OrderStatus.Requested || order.orderStatus === OrderStatus.Rejected) {
                <span
                  class="badge rounded-pill order-status-badge"
                  [ngStyle]="getStatusStyle(order.orderStatus)">
                  {{ getStatusLabel(order.orderStatus) }}
                </span>
              } @else {
                <span
                  class="badge rounded-pill order-status-badge"
                  [ngStyle]="getProgressStyle(order.orderProgress)">
                  {{ getProgressLabel(order.orderProgress) }}
                </span>
              }
            </span>

            <span class="order-expand-icon" aria-hidden="true">
              <fa-icon [fixedWidth]="true" [icon]="faChevronDown"></fa-icon>
            </span>
          </button>

          @if (expandedOrderIds.includes(order.id)) {
            <div class="order-details" [id]="'order-details-' + order.id">
              <div class="row g-4 align-items-stretch">
                <div class="col-12 col-xl-6 d-flex">
                  <div class="order-dental-column flex-fill">
                    <app-dental-arches [products]="order.products"></app-dental-arches>
                  </div>
                </div>

                <div class="col-12 col-xl-6 d-flex">
                  <div class="order-collaboration d-flex flex-column flex-fill border rounded-4 overflow-hidden bg-white">
                    <div class="nav nav-pills order-collaboration-tabs flex-nowrap gap-1 p-2" role="tablist" aria-label="Детали, пораки и датотеки" (keydown)="onOrderTabKey($event, order.id)">
                      @for (tab of orderTabs; track tab.id) {
                        <button type="button" class="nav-link flex-fill text-nowrap" role="tab"
                          [class.active]="selectedOrderTab(order.id) === tab.id"
                          [id]="tab.id + '-tab-' + order.id" [attr.aria-controls]="tab.id + '-panel-' + order.id"
                          [attr.aria-selected]="selectedOrderTab(order.id) === tab.id"
                          [tabIndex]="selectedOrderTab(order.id) === tab.id ? 0 : -1"
                          (click)="selectOrderTab(order.id, tab.id)">
                          {{ tab.label }}
                          @if (tab.id === 'communication' && communication.unreadMessageCounts()[order.id]) {
                            <span class="badge rounded-pill bg-danger ms-1">{{communication.unreadMessageCounts()[order.id]}}<span class="visually-hidden"> непрочитани пораки</span></span>
                          }
                          @if (tab.id === 'files') { <span class="badge rounded-pill ms-1">{{ order.files.length }}</span> }
                        </button>
                      }
                    </div>
                      <section class="p-3 p-md-4" role="tabpanel" tabindex="0"
                          [id]="'details-panel-' + order.id" [attr.aria-labelledby]="'details-tab-' + order.id"
                          [hidden]="selectedOrderTab(order.id) !== 'details'">
                        <div class="order-details-header">
                          <div>
                            <div class="order-section-eyebrow">Информации</div>
                            <h5 class="order-details-heading mb-0">Детали за налогот</h5>
                          </div>

                          @if (canModifyOrder(order)) {
                            <div class="order-details-actions d-flex align-items-center justify-content-end gap-2">
                              <a
                                class="btn app-btn-square rounded-3 order-details-icon-button order-details-edit-button"
                                [routerLink]="['/orders', order.id, 'edit']"
                                matTooltip="Уреди го налогот"
                                aria-label="Уреди го налогот"
                                (click)="$event.stopPropagation()">
                                <fa-icon [fixedWidth]="true" [icon]="faPenToSquare"></fa-icon>
                              </a>
                              <button
                                type="button"
                                class="btn app-btn-soft app-btn-square rounded-3 order-details-icon-button order-details-delete-button"
                                matTooltip="Избриши го налогот"
                                aria-label="Избриши го налогот"
                                (click)="openDeleteOrderModal($event, order)">
                                <fa-icon [fixedWidth]="true" [icon]="faTrash"></fa-icon>
                              </button>
                            </div>
                          }
                        </div>

                        <div class="order-detail-block">
                          <div class="order-detail-label">Изработки</div>
                          <div class="order-products" [id]="'productDetails-' + order.id">
                            @for (product of groupProductsByName(order.products); track product.name) {
                              <div class="order-product-row">
                                <div class="order-product-icon">
                                  <fa-icon [ngStyle]="{color: product.color}" [fixedWidth]="true" size="lg" [icon]="faTooth"/>
                                </div>
                                <div class="order-product-name">{{ product.name }}</div>
                                <span class="order-product-quantity">{{product.quantity}}</span>
                              </div>
                            }
                          </div>
                        </div>

                        <div class="order-detail-meta">
                          @if (order.toothColor != null) {
                            <div class="order-detail-block">
                              <div class="order-detail-label">Боја</div>
                              <div class="order-detail-value">{{ToothColors[order.toothColor]}}</div>
                            </div>
                          }

                          <div class="order-detail-block order-description-block">
                            <div class="order-detail-label">Опис</div>
                            @if (order.description) {
                              <p class="order-description mb-0">{{order.description}}</p>
                            } @else {
                              <p class="order-description order-description-empty mb-0">Нема дополнителен опис.</p>
                            }
                          </div>
                        </div>
                      </section>
                <div class="order-message-panel flex-grow-1" role="tabpanel" tabindex="0" [id]="'communication-panel-' + order.id" [attr.aria-labelledby]="'communication-tab-' + order.id" [hidden]="selectedOrderTab(order.id) !== 'communication'">
                  <app-order-chat [orderId]="order.id" [active]="selectedOrderTab(order.id) === 'communication'" />
                </div>
              <section class="order-files-panel p-3 p-md-4" role="tabpanel" tabindex="0" [id]="'files-panel-' + order.id" [attr.aria-labelledby]="'files-tab-' + order.id" [hidden]="selectedOrderTab(order.id) !== 'files'">
                <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
                  <div>
                    <h5 class="mb-0">
                      Датотеки
                      <span class="order-files-count">{{ order.files.length }}</span>
                    </h5>
                  </div>
                  <button
                    type="button"
                    class="btn primary-btn rounded-3"
                    (click)="openOrderUploadModal($event, order.id)">
                    Прикачи датотека
                  </button>
                </div>

                <div class="table-responsive w-100 app-table-card order-files-table-wrapper" role="region" aria-label="Датотеки на налогот" tabindex="0">
                @if (order.files && order.files.length > 0) {
                    <table class="table table-hover mb-0 align-middle app-data-table order-files-table order-files-table-compact">
                      <thead>
                        <tr>
                          <th scope="col">Датотека</th>
                          <th scope="col" class="file-preview-column" aria-label="Преглед"></th>
                          <th scope="col" class="text-center order-file-action-column">
                            <span class="visually-hidden">Преземи</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (file of order.files; track file.id) {
                          <tr>
                            <td class="text-start">
                              <span class="fw-semibold order-file-name">{{ file.fileName || file.name }}</span>
                              @if (file.description) {
                                <div class="small text-muted text-break mt-1">{{ file.description }}</div>
                              }
                              <div class="small text-muted mt-1">
                                {{ formatBytes(file.sizeInBytes) }} <span aria-hidden="true">&middot;</span> {{ file.dateAdded | appDate:'date':formatting.formats() }}
                              </div>
                            </td>
                            <td class="text-center file-preview-column">
                              @if (isPreviewableImage(file)) { <app-file-image-preview [file]="file" /> }
                            </td>
                            <td class="text-center order-file-action-column">
                              <div class="d-flex align-items-center justify-content-center gap-2">
                                <button
                                  type="button"
                                  class="btn primary-outline-btn rounded-3 d-inline-flex align-items-center gap-2 order-file-action-button"
                                  [disabled]="isDownloading(file.id)"
                                  [attr.title]="isDownloading(file.id) ? 'Преземање' : 'Преземи'"
                                  [attr.aria-label]="'Преземи ја датотеката ' + (file.fileName || file.name || '')"
                                  (click)="$event.stopPropagation(); downloadFile(file)">
                                  @if (isDownloading(file.id)) {
                                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <span class="visually-hidden">Преземање</span>
                                  } @else {
                                    <fa-icon [icon]="faDownload"></fa-icon>
                                    <span class="visually-hidden">Преземи</span>
                                  }
                                </button>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                } @else {
                  <app-no-items-found text="Нема прикачени датотеки."></app-no-items-found>
                }
                </div>
              </section>
                </div>
                </div>
              </div>
            </div>
          }
          </article>

          <div class="modal fade" [id]="'orderUploadFileModal-' + order.id" tabindex="-1" [attr.aria-labelledby]="'orderUploadFileModalLabel-' + order.id" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content" (click)="$event.stopPropagation()">
                <div class="modal-header">
                  <h5 class="modal-title" [id]="'orderUploadFileModalLabel-' + order.id">Прикачи датотека</h5>
                  <button type="button" class="btn-close" aria-label="Затвори" (click)="hideOrderUploadModal(order.id)"></button>
                </div>
                <div class="modal-body p-4">
                  <app-create-files
                    [inModal]="true"
                    [orderId]="order.id"
                    (completed)="handleOrderFileCreated(order.id, $event)"
                    (cancelled)="hideOrderUploadModal(order.id)">
                  </app-create-files>
                </div>
              </div>
            </div>
          </div>

</ng-template>
